import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Injectable()
export class PasswordChangeForm {

  constructor(private formBuilder: FormBuilder) {
  }

  public buildForm(): FormGroup {
    return this.formBuilder.group({
      password: [ '', Validators.required ],
      passwordConfirm: [ '', Validators.required ],
      hash: [ '', Validators.required ]
    });
  }
}
